<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'detail-perangkat'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Detail Perangkat WA" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content v-if="formReady">
                <div class="p-t-16">
                    <div class="m-d-16">
                        <DeviceStatus :data-status="getStatusMesin" :data-mesin="dataDevice" />
                    </div>
                    <div class="p-x-20 m-d-20">
                        <DeviceEdit :data-device="dataDevice" />
                        <div class="notice m-d-16" v-if="isNotPaid" @click="gotoBill">
                            <IconBased>
                                <template v-slot:icons>
                                    <InfoCircleGrey />
                                </template>
                            </IconBased>
                            <div class="m-l-12 m-r-12">
                                <label class="m-d-0 f-c-midgrey f-12 f-regular">
                                    Segera selesaikan pembayaran untuk mulai menggunakan fitur WA.
                                </label>
                            </div>
                            <IconBased>
                                <template v-slot:icons>
                                    <NextStep />
                                </template>
                            </IconBased>
                        </div>
                        <div class="sisa-quota p-x-12 f-14 m-d-16 f-c-midgrey f-regular">
                            <div class="d-flex-between-center p-y-8" style="border-bottom: 1px solid #EDEDED;">
                                <label class="m-d-0">Sisa kuota:</label>
                                <label class="m-d-0">{{ dataDevice.kuota }} pesan</label>
                            </div>
                            <div class="d-flex-between-center p-y-8">
                                <label class="m-d-0">Antrian:</label>
                                <label class="m-d-0">{{ dataDevice.antrian }} pesan</label>
                            </div>
                            <div class="p-y-12">
                                <label class="m-d-8" v-if="isAutoUpdate == 1">
                                    Akan diperpanjang pada
                                    {{ $moment(dataDevice.masa_aktif).format("Do MMM YYYY HH:mm") }}
                                </label>
                                <label class="m-d-8" v-else>
                                    Aktif sampai
                                    {{ $moment(dataDevice.masa_aktif).format("Do MMM YYYY HH:mm") }}
                                </label>
                                <div class="d-flex" style="align-items: center;">
                                    <SOInputOnOff
                                        :checkboxes="autoUpdate"
                                        @selected="toogleOnOff"
                                        :checked="isAutoUpdate == 1 ? true : false"
                                        :disabled="!validateAccess('whatsappDevice.update')"
                                        
                                    />
                                    <div class="m-l-8" @click="showDetailRenew">
                                        <IconBased width="18" height="18">
                                            <template v-slot:icons>
                                                <QuestionMarkCircle />
                                            </template>
                                        </IconBased>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sisa-quota p-x-12 f-14 f-c-midgrey f-regular">
                            <div class="p-y-12">
                                <label class="m-d-8">
                                    Dengan menonaktifkan penggunaan wa manual, 
                                    kasir tidak di izinkan kirim nota secara manual semua pesan akan dikirim secara otomatis
                                </label>
                                <div class="d-flex" style="align-items: center;"  @click.prevent.stop="toggleEnableWaManual()">
                                    <SOInputOnOff
                                        :checkboxes="waManual"
                                        :checked="dataDevice.disable_wa_manual > 0"
                                        :disabled="!validateAccess('whatsappDevice.update')"
                                        
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="separator"></div>
                    <div class="wa-blast-status p-x-20">
                        <div class="d-flex p-y-16" style="align-items: center;" v-if="validateAccess('whatsappDevice.blast')" @click="gotoWaBlast">
                            <IconBased width="20" height="21">
                                <template v-slot:icons>
                                    <WhatsappIcon />
                                </template>
                            </IconBased>
                            <div class="" style="margin-left: 18px;">
                                <p class="m-d-0 f-16 f-c-black f-semi">Blast Whatsapp</p>
                                <p class="m-d-0 f-14 f-regular f-c-midgrey">Kirim banyak pesan sekaligus</p>
                            </div>
                        </div>
<!--                        <div class="d-flex p-y-16" style="align-items: center;" @click="gotoWaStatus">-->
<!--                            <IconBased width="22" height="23">-->
<!--                                <template v-slot:icons>-->
<!--                                    <PlusCircleBlue />-->
<!--                                </template>-->
<!--                            </IconBased>-->
<!--                            <div class="" style="margin-left: 18px;">-->
<!--                                <p class="m-d-0 f-16 f-c-black f-semi">Status Whatsapp</p>-->
<!--                                <p class="m-d-0 f-14 f-regular f-c-midgrey">Buat pembaruan status di perangkat ini</p>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="d-flex p-y-16" style="align-items: center;" v-if="validateAccess('whatsappDevice.update')" @click="gotoTestPesan">
                            <SOIconBase width="24" height="24" view-box="0 0 24 24">
                                <template v-slot:icon>
                                    <Mail2424 icon-fill="#206CFF" />
                                </template>
                            </SOIconBase>
                            <div class="" style="margin-left: 18px;">
                                <p class="m-d-0 f-16 f-c-black f-semi">Kirim Tes Pesan</p>
                                <p class="m-d-0 f-14 f-regular f-c-midgrey">
                                    Kirim Pesan untuk memastikan perangkat terhubung
                                </p>
                            </div>
                        </div>
                        <div class="d-flex p-y-16" style="align-items: center;" @click="goSetBot()" v-if="validateAccess('whatsappDevice.chatBot') && isWebview()">
                            <SOIconBase width="24" height="24" view-box="0 0 24 24">
                                <template v-slot:icon>
                                    <Setting2424 icon-fill="#206CFF" />
                                </template>
                            </SOIconBase>
                            <div class="" style="margin-left: 18px;">
                                <p class="m-d-0 f-16 f-c-black f-semi"> WA Chat-Bot </p>
                                <p class="m-d-0 f-14 f-regular f-c-midgrey">
                                    Pengaturan Chat-Bot untuk Self Service
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="separator"></div>
                    <div class="sub-menu p-x-20">
                        <div
                            v-for="menu in getSubMenus"
                            :key="`menu-${menu.id}`"
                            class="d-flex-between-center menu-item"
                            @click="gotoPage(menu)"
                        >
                            <div>
                                <p class="m-d-0 f-16 f-c-black f-semi">{{ menu.title }}</p>
                                <p class="m-d-0 f-14 f-c-midgrey f-regular">{{ getSubTitle(menu) }}</p>
                            </div>
                            <div>
                                <IconBased>
                                    <template v-slot:icons>
                                        <NextStep icon-fill="#C8D0DD" />
                                    </template>
                                </IconBased>
                            </div>
                        </div>
                    </div>
                    <div class="separator"></div>
                    <div class="d-flex p-y-16 p-x-20" style="align-items: center;" id="btnHpus" v-if="validateAccess('whatsappDevice.delete')" @click="confirmDelete">
                        <IconBased width="20" height="22">
                            <template v-slot:icons>
                                <TrashRed />
                            </template>
                        </IconBased>
                        <div class="" style="margin-left: 18px;">
                            <p class="m-d-0 f-16 f-c-black f-semi">Hapus perangkat ini</p>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff.vue";

import DeviceStatus from "../components/DeviceStatus.vue";
import DeviceEdit from "../components/DeviceEdit.vue";

import IconBased from "../components/iconPack/IconBased.vue";
import InfoCircleGrey from "../components/iconPack/InfoCircleGrey.vue";
import NextStep from "../components/iconPack/NextStep0812.vue";
import QuestionMarkCircle from "../components/iconPack/QuestionMarkCircle1818.vue";
import WhatsappIcon from "../components/iconPack/WhatsappIcon.vue";
import PlusCircleBlue from "../components/iconPack/PlusCircleBlue.vue";
import TrashRed from "../components/iconPack/TrashRed2022.vue";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import Mail2424 from "@/so-components/global/icons/iconPacks/Mail2424.vue";
import Setting2424 from "@/so-components/global/icons/iconPacks/Setting2424.vue";

import statusMesin from "../static/statusMesin";
import subMenus from "../static/subMenus";
import { moduleName } from "../store/state";

const autoUpdate = () => ({
    name: "jenis-paket",
    data: [
        {
            id: "jenis-paket-deposit",
            value: "1",
            title: `<label class='f-regular f-14 f-c-black m-0' for='jenis-paket-deposit'>Diperpanjang otomatis</label>`,
            checked: false,
            titleBold: false,
        },
    ],
});

const waManual = () => ({
    name: "wa-manual",
    data: [
        {
            id: "disable-wa",
            value: "1",
            title: `<label class='f-regular f-14 f-c-black m-0' for='disable-wa'>Non Aktifkan WA Manual</label>`,
            checked: false,
            titleBold: false,
        },
    ],
});

export default {
    name: "DeviceDetail",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOHeaderList,
        SOLoadingPage,
        SOInputOnOff,
        DeviceStatus,
        DeviceEdit,
        IconBased,
        InfoCircleGrey,
        NextStep,
        QuestionMarkCircle,
        WhatsappIcon,
        PlusCircleBlue,
        TrashRed,
        SOIconBase,
        Mail2424,
        Setting2424,
    },
    data() {
        return {
            formReady: false,
            autoUpdate: autoUpdate(),
            waManual: waManual(),
            routeHistory: null,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setRouteHistory(from.name);

            if (from.name === "wa_autosender.detail_perangkat.confirm_delete") {
                document.getElementById("btnHpus").scrollIntoView();
            }
        });
    },
    mounted() {
        this.init();
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "wa_autosender.daftar_perangkat") {
            this.resetListPerangkat();
        }
        next();
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
                if (
                    this.routeHistory === "wa_autosender.detail_perangkat.riwayat_paket" ||
                    this.routeHistory === "wa_autosender.detail_perangkat.riwayat_pesan"
                ) {
                    this.scrollTo();
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            dataDevice: "dataDevice",
            dataDeviceTiny: "dataDeviceTiny",
            response: "response",
        }),
        getStatusMesin() {
            return statusMesin.find((st) => st.kode === this.dataDevice.status);
        },
        isNotPaid() {
            return this.dataDevice.status === 2;
        },
        isAutoUpdate() {
            return this.dataDevice.auto_renewal;
        },
        getSubMenus() {
            return subMenus;
        },
        getIdDevice() {
            return this.$route.params.id_device;
        },
        getSubTitle() {
            return (menu) => {
                if (menu.id === "m-1") {
                    return `${this.dataDevice.outlet} ${menu.subTitle}`;
                } else if (menu.id === "m-2") {
                    let lastMessage = this.dataDevice.last_message
                        ? this.$moment(this.dataDevice.last_message).format("Do MMM YYYY HH:mm")
                        : "";
                    return `${menu.subTitle} ${lastMessage}`;
                } else if (menu.id === "m-3") {
                    let lastBuy = this.dataDevice.last_buy_paket
                        ? this.$moment(this.dataDevice.last_buy_paket).format("Do MMM YYYY HH:mm")
                        : "";
                    return `${menu.subTitle} ${lastBuy}`;
                }
            };
        },
    },
    methods: {
        ...mapActions({
            getDetailDevice: `${moduleName}/getDetailDevice`,
            setDataDeviceItem: `${moduleName}/setDataDeviceItem`,
            updateDeviceDetail: `${moduleName}/updateDeviceDetail`,
            resetListPesan: `${moduleName}/resetListPesan`,
            resetListOutlet: `${moduleName}/resetListOutlet`,
            resetListPerangkat: `${moduleName}/resetListPerangkat`,
        }),
        goSetBot() {
            this.flutterNavigate('snap-wa-bot/settings/' + this.getIdDevice)
        },
        setRouteHistory(name) {
            this.routeHistory = name;
        },
        back() {
            this.$router.push({ name: "wa_autosender.daftar_perangkat" });
        },
        init() {
            this.getDetailDevice({ id_mesin: this.getIdDevice });
        },
        setFormReady(val) {
            this.formReady = val;
        },
        showDetailRenew() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.info_renew" });
        },
        gotoBill() {
            this.$router.push({
                name: "wa_autosender.pembayaran",
                params: { id_device: this.dataDevice.iddevice, id_bill: this.dataDevice.idbill },
            });
        },
        toogleOnOff(e) {
            this.setDataDeviceItem({ val: e ? 1 : 0, key: "auto_renewal" });
            this.$router.push({ name: "wa_autosender.detail_perangkat.ubah_renew", params: { prev_val: !e } });
        },

        async toggleEnableWaManual() {
            // console.log(!e);
            this.setFormReady(true);
            this.dataDevice.disable_wa_manual = this.dataDevice.disable_wa_manual > 0 ? 0 : 1;
            this.updateDeviceDetail(this.dataDevice)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.getDetailDevice({ id_mesin: data.iddevice });
                        this.resetListPerangkat();
                        this.$toast.success(msg);
                    } else {
                        this.setResponse(resulter.errorResult(msg));
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
                this.setFormReady(false);
        },
        confirmDelete() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.confirm_delete" });
            this.smartTrackingClick('hapus_perangkat_whatsapp')

        },
        gotoWaBlast() {
            this.$router.push({ name: "wa_blast.list" });
            this.smartTrackingClick("blast_whatsapp");

        },
        gotoWaStatus() {
            this.$router.push({ name: "wa_status.list", params: { deviceId: this.getIdDevice } });
        },
        gotoTestPesan() {
            this.$router.push({
                name: "wa_autosender.connect_perangkat.connected",
                params: { id_device: this.getIdDevice },
            });
            this.smartTrackingClick("test_pesan_whatsapp");
        },
        async gotoPage(menu) {
            if (menu.id === "m-3") {
                this.$router.push({ name: "wa_autosender.detail_perangkat.riwayat_paket" });
                this.smartTrackingClick('riwayat_beli_paket_whatsapp')
            } else if (menu.id === "m-2") {
                await this.resetListPesan();
                await this.$router.push({ name: "wa_autosender.detail_perangkat.riwayat_pesan" });
                this.smartTrackingClick('riwayat_pesan_whatsapp')
            } else if (menu.id === "m-1") {
                await this.resetListOutlet();
                await this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet" });
                this.smartTrackingClick('outlet_integrasi_whatsapp')
            }
        },
        scrollTo() {
            setTimeout(() => {
                let el = document.getElementById("btnHpus");
                if (el) {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop;
                }
            }, 100);
        },
    },
};
</script>
<style scoped>
.notice {
    border: 1px solid #ededed;
    background: #f6f6f6;
    display: flex;
    align-items: center;
    padding: 8px 13px;
    border-radius: 8px;
    flex-direction: row;
    justify-content: center;
}
.sisa-quota {
    background: #ffffff;
    border: 1px solid #ededed;
    box-sizing: border-box;
    border-radius: 8px;
}
.menu-item {
    padding: 16px 0px;
    border-bottom: 1px solid #ededed;
}
</style>
